import React from "react";
import Tooltip from "../../common-components/Tooltip";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setActiveNavbarTab } from "../../../redux-store/slice/activeNavbarSlice";
import { useTranslation } from 'react-i18next';
import grayHome from "../../../images/home_gray.svg";
import blueHome from "../../../images/home_blue.svg";
import grayUser from "../../../images/User_grey.svg";
import blueUser from "../../../images/user_blue.svg";
import grayRoster from "../../../images/RosterGrey.svg";
import blueRoster from "../../../images/RosterBlue.svg";
import grayHandouts from "../../../images/HandoutGrey.svg";
import blueHandouts from "../../../images/HandoutBlue.svg";
import grayGeoAnalytics from "../../../images/geoGrey.svg";
import blueGeoAnalytics from "../../../images/geoBlue.svg";
import grayMessage from "../../../images/MessageGrey.svg";
import blueMessage from "../../../images/MessageBlue.svg";
import grayMainDash from "../../../images/AnalyticsGrey.svg";
import blueMainDash from "../../../images/AnalyticsBlue.svg";
import patientListGray from "../../../images/patientlistGrey.svg";
import patientListBlue from "../../../images/patientListBlue.svg";
import graySetting from "../../../images/setGrey.svg";
import blueSetting from "../../../images/setBlue.svg";
import graySlot from "../../../images/setGrey.svg";
import blueSlot from "../../../images/setBlue.svg";
import grayIPD from "../../../images/setGrey.svg";
import blueIPD from "../../../images/setBlue.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHospital, faHospitalUser, faPills, faBuilding, faReceipt, faComments, faBullhorn, faUserDoctor, faCalendarDays, faUserSecret, faSliders } from "@fortawesome/free-solid-svg-icons";

const Navbar = () => {
  const activeNavbar = useSelector((state) => state.activeNavbar);
  // const activeDrawer = useSelector((state) => state.dashboardDrawer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const handleActiveNavbar = (value) => {
    dispatch(setActiveNavbarTab(value));
    
    // Navigate to specific routes for PHR App sections
    if (value === "campaign_management") {
      navigate("/campaign", { replace: true });
    } else if (value === "doctor_information_management") {
      navigate("/doctor-information", { replace: true });
    } else if (value === "hmis_doctor_slot_management") {
      navigate("/hmis-slot-management", { replace: true });
    } else if (value === "user_management") {
      navigate("/user-management", { replace: true });
    } else if (value === "feature_settings") {
      navigate("/feature-settings", { replace: true });
    }
  };

  const { t } = useTranslation();
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const { userType } = userDetails || {};

  return (
    <div>
      {/* {activeDrawer.userDrawer ||
      activeDrawer.checkInDrawer ||
      activeNavbar !== "home" ? ( */}
      <ul>
        {/* <li
          onClick={() => handleActiveNavbar("home")}
          className={`m-3 p-2 flex items-center justify-center rounded-lg ${activeNavbar === "home" ? "bg-[#E1EFFE] text-[#4C6AF7]" : ""
            }`}
        >
          <Tooltip content={t("Home")} placement="left">
            <img
              alt="home"
              src={activeNavbar === "home" ? blueHome : grayHome}
            />
          </Tooltip>
        </li> */}

        {/* <li
          onClick={() => handleActiveNavbar("patient_list")}
          className={`m-3 p-2 items-center flex justify-center rounded-lg ${activeNavbar === "patient_list" ? "bg-[#E1EFFE]" : ""
            }`}
        >
          <Tooltip content={t("Patient List")} placement="left" width="w-20">
            <img
              alt="patient-list"
              src={
                activeNavbar === "patient_list"
                  ? patientListBlue
                  : patientListGray
              }
            />
          </Tooltip>
        </li> */}

        {/* <li
          onClick={() => handleActiveNavbar("ipd_management")}
          className={`m-3 p-2 items-center flex justify-center rounded-lg ${activeNavbar === "ipd_management" ? "bg-[#E1EFFE]" : ""
            }`}
        >
          <Tooltip content={t("IPD Management")} placement="left" width="w-28">
            <FontAwesomeIcon
              icon={faHospital}
              className={`w-5 h-5 ${activeNavbar === "ipd_management" ? "text-[#4C6AF7]" : "text-gray-500"}`}
            />
          </Tooltip>
        </li> */}

        {/* <li
          onClick={() => handleActiveNavbar("medication_inventory")}
          className={`m-3 p-2 items-center flex justify-center rounded-lg ${activeNavbar === "medication_inventory" ? "bg-[#E1EFFE]" : ""
            }`}
        >
          <Tooltip content={t("Medication Inventory")} placement="left" width="w-32">
            <FontAwesomeIcon
              icon={faPills}
              className={`w-5 h-5 ${activeNavbar === "medication_inventory" ? "text-[#4C6AF7]" : "text-gray-500"}`}
            />
          </Tooltip>
        </li> */}

        {/* {userType === "HOSPITALADMIN" && (
          <li
            onClick={() => handleActiveNavbar("department_management")}
            className={`m-3 p-2 items-center flex justify-center rounded-lg ${activeNavbar === "department_management" ? "bg-[#E1EFFE]" : ""
              }`}
          >
            <Tooltip content={t("Department Management")} placement="left" width="w-32">
              <FontAwesomeIcon
                icon={faBuilding}
                className={`w-5 h-5 ${activeNavbar === "department_management" ? "text-[#4C6AF7]" : "text-gray-500"}`}
              />
            </Tooltip>
          </li>
        )} */}

        {/* {userType === "HOSPITALADMIN" && (
          <li
            onClick={() => handleActiveNavbar("billing")}
            className={`m-3 p-2 items-center flex justify-center rounded-lg ${activeNavbar === "billing" ? "bg-[#E1EFFE]" : ""
              }`}
          >
            <Tooltip content={t("Billing")} placement="left" width="w-20">
              <FontAwesomeIcon
                icon={faReceipt}
                className={`w-5 h-5 ${activeNavbar === "billing" ? "text-[#4C6AF7]" : "text-gray-500"}`}
              />
            </Tooltip>
          </li>
        )} */}

        {/* {userType === "HOSPITALADMIN" && (
          <li
            onClick={() => handleActiveNavbar("ai_chat")}
            className={`m-3 p-2 items-center flex justify-center rounded-lg ${activeNavbar === "ai_chat" ? "bg-[#E1EFFE]" : ""
              }`}
          >
            <Tooltip content={t("AI Chat")} placement="left" width="w-20">
              <FontAwesomeIcon
                icon={faComments}
                className={`w-5 h-5 ${activeNavbar === "ai_chat" ? "text-[#4C6AF7]" : "text-gray-500"}`}
              />
            </Tooltip>
          </li>
        )} */}

        {/* <li
          onClick={() => handleActiveNavbar("message")}
          className={`m-3 p-2 items-center flex justify-center rounded-lg ${activeNavbar === "message" ? "bg-[#E1EFFE]" : ""
            }`}
        >
          <Tooltip content={t("Communication")} placement="left">
            <img
              alt="message"
              src={activeNavbar === "message" ? blueMessage : grayMessage}
            />
          </Tooltip>
        </li> */}

        {/* <li
          onClick={() => handleActiveNavbar("medical_handouts")}
          className={`m-3 p-2 items-center flex justify-center rounded-lg ${activeNavbar === "medical_handouts" ? "bg-[#E1EFFE]" : ""
            }`}
        >
          <Tooltip
            content={t("Medical Handouts")}
            placement="left"
            width="w-28"
          >
            <img
              alt="handouts"
              src={
                activeNavbar === "medical_handouts"
                  ? blueHandouts
                  : grayHandouts
              }
            />
          </Tooltip>
        </li> */}

        {/* <li
          onClick={() => handleActiveNavbar("location")}
          className={`m-3 p-2 flex items-center justify-center rounded-lg ${
            activeNavbar === "location" ? "bg-[#E1EFFE]" : ""
          }`}
        >
          <Tooltip
            content={t("Geo-Visit Analytics")}
            placement="left"
            width="w-40"
          >
            <img
              alt="geo"
              src={
                activeNavbar === "location"
                  ? blueGeoAnalytics
                  : grayGeoAnalytics
              }
            />
          </Tooltip>
        </li> */}
        {/* <li
          onClick={() => handleActiveNavbar("mainDashboard")}
          className={`m-3 pe-2 ps-3 py-2 flex items-center rounded-lg ${
            activeNavbar === "mainDashboard"
              ? "bg-[#E1EFFE] text-[#4C6AF7]"
              : "text-[#6B7280]"
          }`}
        >
          <Tooltip
            content={t("Analytics Dashboard")}
            placement="left"
            width="w-40"
          >
            <img
              alt="main-dashboard"
              src={
                activeNavbar === "mainDashboard" ? blueMainDash : grayMainDash
              }
            />
          </Tooltip>
        </li> */}

        {/* {userType === "ADMIN" && (
          <li
            onClick={() => handleActiveNavbar("roster")}
            className={`m-3 p-2 items-center flex justify-center rounded-lg ${activeNavbar === "roster" ? "bg-[#E1EFFE]" : ""
              }`}
          >
            <Tooltip content={t("Roster")} placement="left">
              <img
                alt="roster"
                src={activeNavbar === "roster" ? blueRoster : grayRoster}
              />
            </Tooltip>
          </li>
        )} */}

        {userType === "HOSPITALADMIN" && (
          <li
            onClick={() => handleActiveNavbar("user_management")}
            className={`m-3 p-2 items-center flex justify-center rounded-lg ${activeNavbar === "user_management" ? "bg-[#E1EFFE]" : ""
              }`}
          >
            <Tooltip
              content={t("User Management")}
              placement="left"
              width="w-28"
            >
              <FontAwesomeIcon
                icon={faUserSecret}
                className={`w-5 h-5 ${activeNavbar === "user_management" ? "text-[#4C6AF7]" : "text-gray-500"}`}
              />
            </Tooltip>
          </li>
        )}

        {userType === "HOSPITALADMIN" && (
          <li
            onClick={() => handleActiveNavbar("feature_settings")}
            className={`m-3 p-2 items-center flex justify-center rounded-lg ${activeNavbar === "feature_settings" ? "bg-[#E1EFFE]" : ""
              }`}
          >
            <Tooltip
              content={t("Feature Settings")}
              placement="left"
              width="w-28"
            >
              <FontAwesomeIcon
                icon={faSliders}
                className={`w-5 h-5 ${activeNavbar === "feature_settings" ? "text-[#4C6AF7]" : "text-gray-500"}`}
              />
            </Tooltip>
          </li>
        )}

        {(userType === "HOSPITALADMIN" || userType === "MARKETING_USER") && (
          <li
            onClick={() => handleActiveNavbar("campaign_management")}
            className={`m-3 p-2 items-center flex justify-center rounded-lg ${activeNavbar === "campaign_management" ? "bg-[#E1EFFE]" : ""
              }`}
          >
            <Tooltip
              content={t("Campaign Management")}
              placement="left"
              width="w-32"
            >
              <FontAwesomeIcon
                icon={faBullhorn}
                className={`w-5 h-5 ${activeNavbar === "campaign_management" ? "text-[#4C6AF7]" : "text-gray-500"}`}
              />
            </Tooltip>
          </li>
        )}

        {(userType === "HOSPITALADMIN" || userType === "DOCTOR" || userType === "MARKETING_USER") && (
          <li
            onClick={() => handleActiveNavbar("doctor_information_management")}
            className={`m-3 p-2 items-center flex justify-center rounded-lg ${activeNavbar === "doctor_information_management" ? "bg-[#E1EFFE]" : ""
              }`}
          >
            <Tooltip
              content={t("Doctor Information Management")}
              placement="left"
              width="w-40"
            >
              <FontAwesomeIcon
                icon={faUserDoctor}
                className={`w-5 h-5 ${activeNavbar === "doctor_information_management" ? "text-[#4C6AF7]" : "text-gray-500"}`}
              />
            </Tooltip>
          </li>
        )}

        {(userType === "HOSPITALADMIN" || userType === "DOCTOR" || userType === "DOCTOR_INFO_MANAGEMENT_USER") && (
          <li
            onClick={() => handleActiveNavbar("hmis_doctor_slot_management")}
            className={`m-3 p-2 items-center flex justify-center rounded-lg ${activeNavbar === "hmis_doctor_slot_management" ? "bg-[#E1EFFE]" : ""
              }`}
          >
            <Tooltip
              content={t("HMIS Doctor Slot Management")}
              placement="left"
              width="w-40"
            >
              <FontAwesomeIcon
                icon={faCalendarDays}
                className={`w-5 h-5 ${activeNavbar === "hmis_doctor_slot_management" ? "text-[#4C6AF7]" : "text-gray-500"}`}
              />
            </Tooltip>
          </li>
        )}

        {/* {userType === "DOCTOR" && (
          <li
            onClick={() => handleActiveNavbar("slot_management")}
            className={`m-3 p-2 items-center flex justify-center rounded-lg ${activeNavbar === "slot_management" ? "bg-[#E1EFFE]" : ""
              }`}
          >
            <Tooltip
              content={t("Slot Management")}
              placement="left"
              width="w-28"
            >
              <img
                alt="slot-management"
                src={activeNavbar === "slot_management" ? blueSlot : graySlot}
              />
            </Tooltip>
          </li>
        )} */}
        {/* <li
          onClick={() => handleActiveNavbar("setting")}
          className={`m-3 p-2 items-center flex justify-center rounded-lg ${
            activeNavbar === "setting" ? "bg-[#E1EFFE]" : ""
          }`}
        >
          <Tooltip content={t("Settings")} placement="left">
            <img
              alt="setting"
              src={activeNavbar === "setting" ? blueSetting : graySetting}
            />
          </Tooltip>
        </li> */}
      </ul>
      {/* ) : (
        <ul>
          <li
            onClick={() => handleActiveNavbar("home")}
            className={`m-3 py-2 pe-2 ps-3 items-center rounded-lg  ${
              activeNavbar === "home"
                ? "bg-[#E1EFFE] text-[#4C6AF7]"
                : "text-[#6B7280]"
            }`}
          >
            <FontAwesomeIcon
              className="h-5 w-5 me-2 mx-auto"
              icon={faHouse}
              color={activeNavbar === "home" ? "#1A56DB" : "#6B7280"}
            />
            {t("Home")}
          </li>
          {userType === "ADMIN" && (
            <li
              onClick={() => handleActiveNavbar("roster")}
              className={`m-3 pe-2 ps-3 py-2 items-center rounded-lg ${
                activeNavbar === "roster"
                  ? "bg-[#E1EFFE] text-[#4C6AF7]"
                  : "text-[#6B7280]"
              }`}
            >
              <FontAwesomeIcon
                className="h-5 w-5  me-2"
                icon={faUserGroup}
                color={activeNavbar === "roster" ? "#1A56DB" : "#6B7280"}
              />
              {t("Roster")}
            </li>
          )}
          <li
            onClick={() => handleActiveNavbar("mainDashboard")}
            className={`m-3 pe-2 ps-3 py-2 flex items-center rounded-lg ${
              activeNavbar === "mainDashboard"
                ? "bg-[#E1EFFE] text-[#4C6AF7]"
                : "text-[#6B7280]"
            }`}
          >
            <RxDashboard
              className="w-5 h-5 me-3"
              color={activeNavbar === "mainDashboard" ? "#1A56DB" : "#6B7280"}
            />
            {t("Main Dashboard")}
          </li>
          <li
            onClick={() => handleActiveNavbar("location")}
            className={`m-3 pe-2 ps-3 py-2 items-center rounded-lg ${
              activeNavbar === "location"
                ? "bg-[#E1EFFE] text-[#4C6AF7]"
                : "text-[#6B7280]"
            }`}
          >
            <FontAwesomeIcon
              className="h-5 w-5 me-2 mx-auto"
              icon={faLocationDot}
              color={activeNavbar === "location" ? "#1A56DB" : "#6B7280"}
            />
            {t("Geo-Visit Analytics")}
          </li>
          <li
            onClick={() => handleActiveNavbar("message")}
            className={`m-3 pe-2 ps-3 py-2 flex items-center rounded-lg ${
              activeNavbar === "message"
                ? "bg-[#E1EFFE] text-[#4C6AF7]"
                : "text-[#6B7280]"
            }`}
          >
            <BsChatDotsFill
              className="w-5 h-5 me-3"
              color={activeNavbar === "message" ? "#1A56DB" : "#6B7280"}
            />
            {t("Communication")}
          </li>

          <li
            onClick={() => handleActiveNavbar("medical_handouts")}
            className={`m-3 pe-2 ps-3 py-2 flex items-center rounded-lg ${
              activeNavbar === "medical_handouts"
                ? "bg-[#E1EFFE] text-[#4C6AF7]"
                : "text-[#6B7280]"
            }`}
          >
            <TiDocumentText
              className="w-5 h-5 me-3"
              color={
                activeNavbar === "medical_handouts" ? "#1A56DB" : "#6B7280"
              }
            />
            {t("Medical Handouts")}
          </li>

          <li
            onClick={() => handleActiveNavbar("patient_list")}
            className={`m-3 pe-2 ps-3 py-2 flex items-center rounded-lg ${
              activeNavbar === "patient_list"
                ? "bg-[#E1EFFE] text-[#4C6AF7]"
                : "text-[#6B7280]"
            }`}
          >
            <FaHospitalUser
              className="w-5 h-5 me-3"
              color={activeNavbar === "patient_list" ? "#1A56DB" : "#6B7280"}
            />
            {t("Patient List")}
          </li>
          {userType === "ADMIN" && (
            <li
              onClick={() => handleActiveNavbar("user_management")}
              className={`m-3 pe-2 ps-3 py-2 flex items-center rounded-lg ${
                activeNavbar === "user_management"
                  ? "bg-[#E1EFFE] text-[#4C6AF7]"
                  : "text-[#6B7280]"
              }`}
            >
              <FaUserSecret
                className="w-5 h-5 me-3"
                color={
                  activeNavbar === "user_management" ? "#1A56DB" : "#6B7280"
                }
              />
              {t("User Management")}
            </li>
          )}
          <li
            onClick={() => handleActiveNavbar("setting")}
            className={`m-3 pe-2 ps-3 py-2 flex items-center rounded-lg ${
              activeNavbar === "setting"
                ? "bg-[#E1EFFE] text-[#4C6AF7]"
                : "text-[#6B7280]"
            }`}
          >
            <FontAwesomeIcon
              icon={faGear}
              className="w-5 h-5 me-3"
              color={activeNavbar === "setting" ? "#1A56DB" : "#6B7280"}
            />
            {t("Settings")}
          </li>
        </ul>
      )} */}
    </div>
  );
};

export default Navbar;
